"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

/**
 * 组件进入容器的钩子
 * @param target 组件的ref
 * @param options IntersectionObserver的配置
 * @returns {{inViewport: *}}
 */
function useInViewport(target, options) {
  if (options === void 0) {
    options = {};
  }

  var _a = (0, _react.useState)(false),
      inViewport = _a[0],
      setInViewport = _a[1];

  var observer = (0, _react.useRef)(); // 停止监听

  function stopObserver() {
    var _a;

    if ((_a = observer === null || observer === void 0 ? void 0 : observer.current) === null || _a === void 0 ? void 0 : _a.disconnect) {
      observer.current.disconnect();
    }
  } // 开始监听


  function startObserver() {
    if (target.current && observer.current) {
      var node = target.current;

      if (node) {
        observer.current.observe(node);
      }
    }
  } // 监听处理


  var handleIntersection = function handleIntersection(entries) {
    var entry = entries[0] || {};
    var isIntersecting = entry.isIntersecting,
        intersectionRatio = entry.intersectionRatio;
    var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;

    if (isInViewport) {
      setInViewport(true);
      stopObserver();
    }
  }; // 初始化IntersectionObserver


  function initIntersectionObserver() {
    var defaultOptions = {
      rootMargin: '200px',
      threshold: 0
    }; // @ts-ignore

    var root = options.root,
        args = __rest(options, ["root"]); // root为Ref对象


    var rootInter = (root === null || root === void 0 ? void 0 : root.current) && root.current.nodeType === 1 ? root.current : null;
    observer.current = new IntersectionObserver(handleIntersection, __assign(__assign(__assign({}, defaultOptions), args), {
      root: rootInter
    }));
  }

  (0, _react.useEffect)(function () {
    initIntersectionObserver();
    startObserver();
    return function () {
      stopObserver();
    };
  }, []);
  return {
    inViewport: inViewport
  };
}

var _default = useInViewport;
exports["default"] = _default;